module.exports = __webpack_public_path__ + "img/check-icon-2.c8eedcb9.svg";